import { render } from "./ChartPerform.vue?vue&type=template&id=88ea673c&scoped=true"
import script from "./ChartPerform.vue?vue&type=script&lang=js"
export * from "./ChartPerform.vue?vue&type=script&lang=js"

import "./ChartPerform.vue?vue&type=style&index=0&id=88ea673c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88ea673c"]])

export default __exports__